import { PipesModule } from "src/app/_pipes/pipes.module";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { IonicModule } from "@ionic/angular";
import { FormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { SpaceBookingViewComponent } from "./space-booking-view.component";
import { PopoverComponentModule } from "src/app/app/_component/popover/popover.module";
import { ImagePreviewModule } from "src/app/app/_component/image-preview/image-preview.module";
import { SharedDirectivesModule } from "src/app/_directives/shared-directives.module";
import { QRCodeModule } from "angularx-qrcode";
import { StatusModule } from "../../status/status.module";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule,
    RouterModule,
    SharedDirectivesModule,
    PopoverComponentModule,
    ImagePreviewModule,
    PipesModule,
    StatusModule
  ],

  declarations: [SpaceBookingViewComponent],
  exports: [SpaceBookingViewComponent],
})
export class ParkingBookingViewModule {}
